<template>
<div>
  <div class="container">
    <h1>Einstellungen</h1>
  </div>
   <div class="list container">
        <div class="row mb-5">
            <div class="col-4">

               <h2 class="text-left">Freiburger Stadtteile</h2>
                <mdb-select v-model="freiburgOptions" @change="changeSelectedOrtFreiburg($event)" label="Stadtteil auswählen"></mdb-select>
                <mdb-input v-model="freiburgOptionsRename" label="ausgewählten Stadtteil umbenennen"></mdb-input>
                <div class="d-flex mb-5">
                  <mdb-btn color="danger" type="submit" v-on:click="renameFreiburgOrt" >Umbenennen</mdb-btn>
                </div>
              <div class="tasks__new input-group d-flex flex-column">
              <mdb-input v-model="newFreiburgOrt" placeholder="Neuen Stadtteil hinzufügen"></mdb-input>
              <div class="d-flex">
                  <mdb-btn color="danger" type="submit" v-on:click="removeFreiburgOrt" >Entfernen</mdb-btn>
                <mdb-btn color="primary" type="submit" v-on:click="addFreiburgOrt" >Hinzufügen</mdb-btn>

              </div>
              

            </div>

        </div>
            <div class="col-4 offset-2">
                    <h2 class="text-left">Orte in der Umgebung von Freiburg</h2>
                    <mdb-select v-model="umgebungOptions" @change="changeSelectedOrtUmgebung($event)" label="Ort auswählen" ></mdb-select>
                  <mdb-input v-model="umgebungsOptionsRename" label="ausgewählten Ort umbenennen"></mdb-input>
                  <div class="d-flex mb-5">
                    <mdb-btn color="danger" type="submit" v-on:click="renameUmgebungOrt" >Umbenennen</mdb-btn>
                  </div>
                    <div class="tasks__new input-group d-flex flex-column">
                        <mdb-input v-model="newUmgebungOrt" placeholder="Neuer Ort hinzufügen"></mdb-input>
                        <div class="d-flex">
                            <mdb-btn color="danger" type="submit" v-on:click="removeUmgebungOrt" >Entfernen</mdb-btn>
                            <mdb-btn color="primary" type="submit" v-on:click="addUmgebungOrt" >Hinzufügen</mdb-btn>

                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
   

</template>

<script>

import json from './Settings.json';
import SettingService from '@/services/SettingsService';
import { mdbBtn, mdbInput, mdbSelect } from 'mdbvue';


export default {
  name: "Settings",
  components: {
    mdbBtn,
    mdbInput,
    mdbSelect
  },
  data() {
    return {
      myJson: json,
      newFreiburgOrt: '',
      newUmgebungOrt: '',
      newZimmerart: '',
      newNebenkostenart: '',
      listFreiburg: '',
      listUmgebung: '',
      freiburgOptionsRename: '',
      umgebungsOptionsRename: '',
      freiburgOptions: [],
      umgebungOptions: [],
        selectedOrtUmgebung: '',
        selectedOrtFreiburg: '',
    }
  },
  methods:{
      changeSelectedOrtFreiburg(event) {
          this.selectedOrtFreiburg = event;
      },
      changeSelectedOrtUmgebung(event) {
          this.selectedOrtUmgebung = event;
      },
      createFreiburgList(array){
          
              let liste = [];
              for(let i = 0; i < array.length; i++){
                let item = {text: array[i].SettingValue.toString(), value:array[i].SettingId, index: i};
                liste.push(item)
              }
              this.freiburgOptions = liste;
              
      },
      renameFreiburgOrt(){
        if(this.selectedOrtFreiburg && this.freiburgOptionsRename){
          SettingService.updateSettingsName(this.selectedOrtFreiburg, this.freiburgOptionsRename).then(response =>{
            this.getSettings();
            this.$notify.success({
              message: "Der Ort wurde umbenannt.",
              position: 'top right',
              timeout: 3000
            });
            this.freiburgOptionsRename = '';
          }).catch(error =>{
            this.$notify.warn({
              message: "Es gab ein Fehler beim speichern.",
              position: 'top right',
              timeout: 3000
            });
          });
        } else {
          this.$notify.warn({
            message: "Keinen Ort ausgewhält.",
            position: 'top right',
            timeout: 3000
          });
        }
      },
      renameUmgebungOrt(){
      if(this.selectedOrtUmgebung && this.umgebungsOptionsRename){
        SettingService.updateSettingsName(this.selectedOrtUmgebung, this.umgebungsOptionsRename).then(response =>{
          this.getSettingsUmgebung();
          this.$notify.success({
            message: "Der Ort wurde umbenannt.",
            position: 'top right',
            timeout: 3000
          });
          this.umgebungsOptionsRename = '';
        }).catch(error =>{
          this.$notify.warn({
            message: "Es gab ein Fehler beim speichern.",
            position: 'top right',
            timeout: 3000
          });
        });
      } else {
        this.$notify.warn({
          message: "Keinen Ort ausgewhält.",
          position: 'top right',
          timeout: 3000
        });
      }
    },
      addFreiburgOrt(){
          if(this.newFreiburgOrt != ""){
              SettingService.updateSettings(this.newFreiburgOrt, 1).then(response =>{
                  this.getSettings();
                  this.$notify.success({
                      message: "Der neue Ort wurde hinzugefügt.",
                      position: 'top right',
                      timeout: 3000
                  });
                  this.newFreiburgOrt = '';
              }).catch(error =>{
                  this.$notify.warn({
                      message: "Es gab ein Fehler beim speichern.",
                      position: 'top right',
                      timeout: 3000
                  });
              });


          } else {
              this.$notify.warn({
                  message: "Keinen Ort eingegeben.",
                  position: 'top right',
                  timeout: 3000
              });
          }

      },
      removeFreiburgOrt(){
          if(this.selectedOrtFreiburg){
              SettingService.removeSettings(this.selectedOrtFreiburg)
                  .then(response => {
                      this.$notify.warn({
                          message: "Der Ort wurde gelöscht.",
                          position: 'top right',
                          timeout: 3000
                      });
                      this.getSettings();
                  }).catch(error => {
                  this.$notify.error({
                      message: "Ein Error ist beim entfernen aufgetreten.",
                      position: 'top right',
                      timeout: 3000
                  });
                  console.log("There was an error:", error.response);
              });
          } else {
              this.$notify.warn({
                  message: "Keinen Ort zum entfernen ausgewählt.",
                  position: 'top right',
                  timeout: 3000
              });
          }

        

      },

      createUmgebungList(array){

          let liste = [];
          for(let i = 0; i < array.length; i++){
              let item = {text: array[i].SettingValue.toString(), value:array[i].SettingId, index: i};
              liste.push(item)
          }
          this.umgebungOptions = liste;

      },
      addUmgebungOrt(){
          if(this.newUmgebungOrt != ''){
              SettingService.updateSettings(this.newUmgebungOrt, 2)
                  .then(response =>{
                      this.getSettingsUmgebung();
                      this.$notify.success({
                          message: "Der neue Ort wurde hinzugefügt.",
                          position: 'top right',
                          timeout: 3000
                      });
                      this.newUmgebungOrt = '';
                }).catch(error =>{
                  this.$notify.warn({
                      message: "Es gab ein Fehler beim speichern.",
                      position: 'top right',
                      timeout: 3000
                  });
                });
          } else {
              this.$notify.warn({
                  message: "Keinen Ort eingegeben.",
                  position: 'top right',
                  timeout: 3000
              });
          }

      },
      removeUmgebungOrt(){
          if(this.selectedOrtUmgebung){
              SettingService.removeSettings(this.selectedOrtUmgebung)
                  .then(response => {
                      this.$notify.warn({
                          message: "Der Ort wurde gelöscht.",
                          position: 'top right',
                          timeout: 3000
                      });
                      this.getSettingsUmgebung();
                  }).catch(error => {
                  this.$notify.error({
                      message: "Ein Error beim entfernen ist aufgetreten.",
                      position: 'top right',
                      timeout: 3000
                  });
                  console.log("There was an error:", error.response);
              });
          } else {
              this.$notify.warn({
                  message: "Keinen Ort zum entfernen ausgewählt.",
                  position: 'top right',
                  timeout: 3000
              });
          }

      },


      getSettings(){
          SettingService.getSettings(1)
          .then(response => {
              this.createFreiburgList(response.data);
            })
            .catch(error => {
              console.log("There was an error:", error.response);
            });
      },
      getSettingsUmgebung(){
          SettingService.getSettings(2)
              .then(response => {
                  this.createUmgebungList(response.data);
              })
              .catch(error => {
                  console.log("There was an error:", error.response);
              });
      }
  },
  mounted() {
      this.getSettings();
      this.getSettingsUmgebung();
  },
  computed: {
      listNebenkostenArten(){
        
          return this.myJson.Settings[0].nebenkostenArten;
      },
  }

};
</script>
